import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SelectlanguageComponent } from './selectlanguage/selectlanguage.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module';

// common libraries

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, environment.apiUrl + '/api/Translation/', '');
}
@NgModule({
    imports: [
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        FormsModule,
        ReactiveFormsModule,
        PhBhpUiModule
    ],
    exports: [TranslateModule, SelectlanguageComponent],
    declarations: [SelectlanguageComponent]
})
export class PHBHPLocalizePackageModule { }
